import React from "react";
import { Alert, Spin } from 'antd';
import { useSelector } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import TextComponent from "../textComponent/TextComponent";

const Loading = () => {
  const loading = useSelector((state) => state.GeneralReducer.loading);
  const antIcon = <LoadingOutlined style={{ fontSize: 70,color:'var(--secondary-color)' }} spin />;
  return loading ? (
    <div className="loadingClass">
      <Spin indicator={antIcon} />
      <TextComponent text='Loading ...' style={{color:'var(--secondary-color)',fontSize:'20px',fontWeight:'bold',marginTop:15 }}/>
    </div>
  ) : (
    <></>
  );
};

export default Loading;
